module.exports = __webpack_public_path__ + "static/media/welding.b3b49af9.svg";